var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row h1 page-header"},[_vm._v("\n        Your Orders\n    ")]),_vm._v(" "),_c('member-orders-list',{ref:"ordersList"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }